export default __webpack_public_path__ + "05c2a0a229a660cce9e2d31aa3a12c2d.png";